import { AxiosError } from "axios";
import {SHA256} from "crypto-js";

export const getErrorData = (e: unknown) => {
  try {
    if (e instanceof AxiosError && e?.response?.data?.result) {
      return e?.response?.data?.result?.toLowerCase();
    }
  } catch (e) {}
};

export const formatCnic = (input: string) => {
  try {
    let digits = input.toString().replace(/\D/g, "");
    // if (input.length > 0 && !/^[1-7]/.test(input[0])) {
    //   return '';
    // }
    if (digits.length > 5) {
      digits = digits.slice(0, 5) + "-" + digits.slice(5);
    }
    if (digits.length > 13) {
      digits = digits.slice(0, 13) + "-" + digits.slice(13, 14);
    }

    return digits;
  } catch (e) {
    return "";
  }
};

export const isPlanMatch = (
  planSubPackage: string,
  subPackage: string | null
): boolean => {
  if (planSubPackage && subPackage) {
    if (planSubPackage.toLowerCase().includes(subPackage.toLowerCase())) {
      return true;
    }
  }

  return false;
};

export const setCookie = (
  user_Id: any,
  subpackage: any,
  msisdn: any,
  token: any
) => {
  clearAllCookies();
  let data = {
    user_Id: user_Id,
    subpackage: subpackage,
    msisdn: msisdn,
    token: token,
  };
  const maxAge = 30 * 24 * 60 * 60;
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data)
  )}; SameSite=Strict; path=/;  max-age=${maxAge}`;
};

export const getCookie = (name: any) => {
  try {
    const cookies = document.cookie
      .split(";")
      .reduce((acc: Record<string, string>, cookie) => {
        const [key, value] = cookie.split("=");

        acc[key.trim()] = decodeURIComponent(value);
        return acc;
      }, {});
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};
export const clearAllCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const logout = (val?: string) => {
  clearAllCookies();
  window.authToken = undefined;
  if (val === "network") {
    window.location.href = "/landing";
  }
};

export const NavigateToHome = () => {
  let url = window.location.origin + "/home";
  if (url.includes("http:")) {
    url = url.replace("http", "https");
  }
  window.location.replace(url);
};



export const sha256Hash = (value: string) => {
  return SHA256(value.trim().toLowerCase()).toString();
};
